module.exports = "<loading-message [waitFor]=\"user\" [message]=\"'Loading User Detail'\"></loading-message>\r\n\r\n<div *ngIf=\"user\">\r\n\t<button type=\"button\" class=\"btn btn-outline-default btn-sm pull-right\" (click)=\"editUser()\"><i class=\"fa fa-pencil\"></i> Edit</button>\r\n\t<h4>User Detail</h4>\r\n\t<div>{{user.firstName}} {{user.lastName}} <span *ngIf=\"user.admin\">[ADMIN]</span></div>\r\n\t<div><i>{{user.email}}</i></div>\r\n\t\r\n\t<pre>{{user | json}}</pre>\r\n</div>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/user-detail/user-detail.component.html
// module id = ./src/app/admin/user-detail/user-detail.component.html
// module chunks = 0